// UTILS
import { breakpoints, componentsDefaults, iconAliases, theme as afTheme } from '@af-lib/vuetify-config';
import { shallowRef } from 'vue';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, fa } from 'vuetify/iconsets/fa-svg';

// COMPONENTS
import selectIcon from '@/components/selectors/generic/selectIcon';
import { t } from '@/config/i18n';
// CONSTANTS
import { emptyListText } from '@/enums/constants';

export default createVuetify({
  components,
  directives,
  display: breakpoints,

  defaults: {
    ...componentsDefaults,

    VSelect: {
      variant: 'outlined',
      density: 'compact',
      hideDetails: true,
      menuIcon: shallowRef(selectIcon),
      noDataText: t(emptyListText),
      menuProps: { maxHeight: 320, contentClass: 'text-body-3 font-weight-regular' }
    }
  },
  theme: {
    defaultTheme: 'afTheme',
    themes: {
      afTheme
    }
  },
  icons: {
    defaultSet: 'fa',
    aliases: {
      ...aliases,
      ...iconAliases
    },
    sets: {
      fa
    }
  },
  locale: {
    fallback: 'en'
  }
});
